// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/technische-kunststoffteile-und-metallkomponenten-vereint-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const technischeKunststoffteileUndMetallkomponentenVereint2DE: PageEntry = {
  id: "post.technische-kunststoffteile-und-metallkomponenten-vereint-2",
  locale: "de",
  slug: "technische-kunststoffteile-und-metallkomponenten-vereint-2",
  seo: {
    title: "WE FORM SUCCESS - Technische Kunststoffteile und Metallkomponenten vereint | Dietz GmbH",
    description: "WE FORM SUCCESS - Technische Kunststoffteile und Metallkomponenten vereint",
  },
  type: "post",
  h1: "WE FORM SUCCESS - Technische Kunststoffteile und Metallkomponenten vereint",
  blocks: [
    { kind: "heading", level: 2, text: "WE FORM SUCCESS – Technische Kunststoffteile und Metallkomponenten vereint" },
    { kind: "paragraph", text: "Die Dietz GmbH hat sich auf montagefertige Baugruppen spezialisiert, unser moderner Maschinenpark macht es möglich." },
    { kind: "paragraph", text: "Im Bereich Kunststofftechnik verarbeiten wir Thermoplaste, sowie Elastomere mit kundenspezifischen Eigenschaften." },
    { kind: "paragraph", text: "Unsere Metallkomponenten werden durch CNC gesteuerte Maschinen und hochpräzise Werkzeuge hergestellt." },
    { kind: "paragraph", text: "Eine Vielzahl unserer Stanz-Umformteile werden mit unseren Kunststoffteilen durch verschiedeneFertigungsmöglichkeiten vereint, die wir anschließend unseren Kunden einbaufertig zur Verfügung stellen." },
    { kind: "paragraph", text: "Dies Video kann in Ihrem Browser nicht wiedergegeben werden. Eine Download-Version steht unter Hier zum Abruf bereit." },
    { kind: "paragraph", text: "Bei Rückfragen steht Ihnen unser Team gerne zur Verfügung." }
  ],
};
